/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";

import { Popover, Card, Box } from "@mui/material";

const Tooltip = ({ children, title, sx = {} }) => {
  if (!title) {
    return children;
  }

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ ...sx }}>
      <Box
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </Box>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Card
          sx={{
            p: 2,
            boxShadow: 2,
            maxWidth: 550,
            borderRadius: 1,
            bgcolor: "white",
            fontSize: "14px",
            lineHeight: 1.5,
            fontFamily: "Outfit",
          }}
        >
          {title}
        </Card>
      </Popover>
    </Box>
  );
};

export default Tooltip;
